import { parseGwei } from 'viem';
export const gasSpeedUp = (gas, speedUp = 120) => {
    const speedUpGas = (gas * BigInt(speedUp)) / BigInt(100);
    return speedUpGas;
};
export const calcGasFee = ({ gas, gasFeeValue, }, speedUp = true) => {
    const { gasPrice, maxFeePerGas } = gasFeeValue;
    console.log({ gasPrice, maxFeePerGas });
    let gasFee;
    if (maxFeePerGas) {
        gasFee = parseGwei(maxFeePerGas.toString()) * BigInt(gas);
    }
    if (gasPrice) {
        gasFee = parseGwei(gasPrice.toString()) * BigInt(gas);
        console.log('gasFee', gasFee);
    }
    return speedUp && gasFee ? gasSpeedUp(gasFee) : gasFee;
};
//# sourceMappingURL=gas.js.map